import { PGroup, GroupedPermission } from "../../types/Permission";

export const groupPrivilegesByType = (group: PGroup[]): GroupedPermission =>
  group.reduce<GroupedPermission>((acc, current) => {
    if (current.privilege?.length) {
      const key = current.name !== "Client" ? current.name : "Company";
      acc = { ...acc, [key]: current.privilege };
    }
    return acc;
  }, {});
